import script from "./ChatInterface.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInterface.vue?vue&type=script&setup=true&lang=js"

import "./ChatInterface.vue?vue&type=style&index=0&id=3d29a431&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d29a431"]])

export default __exports__